// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__etPfr","loaded":"Auth_loaded__qYZ1s","done":"Auth_done__pa31p","loader":"Auth_loader__LDh-R","spin":"Auth_spin__8NH9B"};